import { useQuery } from '@tanstack/react-query';
import { queryFn, QueryRequest, QueryResponse } from './queryFn';
import type { GraphQLError } from 'graphql';

export const QUERY_KEY = ['ARTICLE'] as const;

export const useArticle = (request: QueryRequest) => {
  return useQuery<QueryResponse, { response: { errors: GraphQLError[] } }>({
    queryKey: [...QUERY_KEY, request.slug],
    queryFn: () => queryFn(request),
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
